// Toast.js — 화면 아래에 잠깐 뜨는 알림. alert 대신 사용
//   const toast = useToast();
//   toast('저장되었습니다.');
//   toast('저장 실패', { type: 'error' });
//   toast('목표를 저장했어요.', { action: { label: '식단 추천 받기', onClick: () => navigate('/DietRecommend') } });
import React, { createContext, useCallback, useContext, useRef, useState } from 'react';
import './ui.css';

const ToastContext = createContext(() => {});

export const useToast = () => useContext(ToastContext);

export function ToastProvider({ children }) {
  const [items, setItems] = useState([]);
  const seq = useRef(0);

  const remove = useCallback((id) => setItems((prev) => prev.filter((t) => t.id !== id)), []);

  const toast = useCallback((message, { type = 'info', action, duration } = {}) => {
    const id = ++seq.current;
    setItems((prev) => [...prev.slice(-2), { id, message, type, action }]);
    setTimeout(() => remove(id), duration ?? (action ? 6000 : 2600));
  }, [remove]);

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div className="toast-stack" role="status" aria-live="polite">
        {items.map((t) => (
          <div key={t.id} className={`toast toast-${t.type}`}>
            <span>{t.message}</span>
            {t.action && (
              <button
                type="button"
                className="toast-action"
                onClick={() => { t.action.onClick(); remove(t.id); }}
              >
                {t.action.label}
              </button>
            )}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}
